import { Button, Space } from "antd";
import { useSelector } from "react-redux";
import { selectUser } from "redux/slices/userSlice";
import K from "utilities/constants";
import {
  getUdfDisplayValue,
  isPermissionPresent,
} from "utilities/generalUtility";
import { CandidateFieldLabel } from "../candidateFieldLabel/candidateFieldLabel";
import { CandidateFieldValue } from "../candidateFieldValue/candidateFieldValue";

export default function UDFDisplayEditableDate({
  item,
  onEdit,
  disabled = false,
  isEditable = true,
  extraLabel = null,
}) {
  const userRoles = useSelector(selectUser).roles;

  const showEditButton =
    isEditable && isPermissionPresent(K.Permissions.EditCandidate, userRoles);

  return (
    <>
      <CandidateFieldLabel extra={extraLabel}>{item.label}</CandidateFieldLabel>

      <Space size={4} style={{ minHeight: 24 }}>
        <CandidateFieldValue>{getUdfDisplayValue(item)}</CandidateFieldValue>

        {showEditButton && (
          <Button
            style={{ width: 16, height: 16 }}
            disabled={disabled}
            onClick={onEdit}
            type="text"
            icon={<i className="icon-edit" />}
          />
        )}
      </Space>
    </>
  );
}
